import React, { useEffect } from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import "../node_modules/bootstrap/dist/js/bootstrap";
import { Provider } from "react-redux";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import store from "./store";
import { Home } from "./components/Home";
import Login from "./components/Login";
import Register from "./components/Register";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import setAuthToken from "./utils/setAuthToken";
import { loadUser } from "./actions/auth";
import ProblemDisplay from "./components/problems/ProblemDisplay";
import Submit from "./components/problems/Submit";
import PrivateRoute from "./components/PrivateRoute";
import RefreshRoute from "./components/RefreshRoute";
import CreateProfile from "./components/profiles/CreateProfile";
import EditProfile from "./components/profiles/EditProfile";
import ComingSoon from "./components/ComingSoon";
import Profile from "./components/profiles/Profile";
import DisplayProfile from "./components/profiles/DisplayProfile";
import ErrorPage from "./components/ErrorPage";

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

const App = () => {
  const [darkMode, setDarkMode] = React.useState(getInitialMode());
  useEffect(() => {
    store.dispatch(loadUser());
  }, []);

  useEffect(() => {
    AOS.init({
      easing: "ease",
      duration: 1600,
      once: true,
    });
  });

  // User based dark mode

  React.useEffect(() => {
    localStorage.setItem("dark", JSON.stringify(darkMode));
  }, [darkMode]);
  const onClick = () => {
    setDarkMode((prevMode) => !prevMode);
    console.log(darkMode);
  };

  function getInitialMode() {
    const isreturnUser = "dark" in localStorage;
    const mode = JSON.parse(localStorage.getItem("dark"));
    const usermodeDark = getModePrefer();

    if (isreturnUser) {
      return mode;
    } else if (usermodeDark) {
      return true;
    } else {
      return false;
    }
  }
  function getModePrefer() {
    if (!window.matchMedia) return;
    return window.matchMedia("(prefer-color-scheme:dark)").matches;
  }

  return (
    <Provider store={store}>
      <Router>
        <div className='light transition'>
          <Nav onClick={onClick} />
          <Switch>
            <Route path='/' exact component={Home} />
            <Route path='/login' exact component={Login} />
            <Route path='/register' exact component={Register} />
            <Route path='/comingsoon' exact component={ComingSoon} />
            <Route path='/profile/:id' exact component={Profile} />
            <PrivateRoute exact path='/problems' component={Dashboard} />
            <PrivateRoute
              exact
              path='/problems/:id'
              component={ProblemDisplay}
            />
            <PrivateRoute
              exact
              path='/problems/:id/submit'
              component={Submit}
            />
            <PrivateRoute exact path='/profile' component={DisplayProfile} />
            <PrivateRoute
              exact
              path='/create-profile'
              component={CreateProfile}
            />
            <PrivateRoute exact path='/edit-profile' component={EditProfile} />
            <Route component={ErrorPage} />
          </Switch>
          <Footer />
        </div>
      </Router>
    </Provider>
  );
};

export default App;
